export const getCategoryBreadCrumbLabels = ({ taxonomy } = {}) => {
  return (taxonomy?.breadCrumbs || []).reduce((filtered, breadCrumb) => {
    if (breadCrumb?.dimensionName === 'Category') {
      filtered.push(breadCrumb.label);
    }
    return filtered;
  }, []);
};

export const getContentBreadCrumbLabels = (crumbs = []) => {
  return crumbs.map((crumb) => crumb?.label);
};